<template>
  <v-container :style="{'background-color': bgColor, 'height': navHeight, 'width': '100%'}"
               :class="`fin-onboarding-slider ${finBrowser.IS_IOS()?'': 'pa-0'}`"
               fluid
  >
    <v-row dense>
      <v-col align="center">
        <fin-numbered-dot-selector :done="done"
                                   :item-labels="itemLabels"
                                   :items="itemLabels.length"
                                   :non-editable="nonEditable"
                                   :show-item-labels="navigationLabel"
                                   :stepsReleasedSuccessively="true"
                                   :style="stepperWidth"
                                   :sub-labels="subLabels"
                                   :value="value"
                                   class="nav"
                                   divider
                                   mark-as-done
                                   @input="val => $emit('input', val)"
        />
      </v-col>
      <v-btn :class="$vuetify.breakpoint.xs ? 'mr-1' : 'mr-8'" @click="$emit('cancel')" icon
             :style="{ position: 'fixed', right: 0, top: $vuetify.breakpoint.smAndDown ? '18px' : '28px' }">
        <v-icon>icon-close</v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import FinNumberedDotSelector from '@/components/common/scrollslider/NumberedDotSelector'
import finBrowser from "@/js/finBrowser"


export default {
  name: 'fin-onboarding-slider',
  components: {
    FinNumberedDotSelector
  },
  props: {
    bgColor: {
      type: String,
      default: 'white'
    },
    nonEditable: {
      type: [Boolean, Array, Number],
      default: true
    },
    value: {
      type: Number,
      default: 1
    },
    navigationLabel: {
      type: Boolean,
      default: false
    },
    subLabels: {
      type: Array,
      default: () => null
    }
  },
  data() {
    return {
      finBrowser: finBrowser,
      activeElem: this.activeElement,
      itemLabels: ['Anlegertyp ermitteln', 'Strategie festlegen', 'Portfolio erstellen'],
      done: false,
      navHeight: 'calc(89px + env(safe-area-inset-top, 0px))'
    }
  },
  computed: {
    stepperWidth() {
      let stepWidth = this.navigationLabel ? '682px' : '400px'

      if (this.$vuetify.breakpoint.smAndDown) {
        stepWidth = '320px'
      }

      return {width: stepWidth}
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.overview-container {
  max-width: 1200px;
}

$nav-height: 100px;

.header {
  background-color: rgba(255, 255, 255, 0.8);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 30;
  min-height: $nav-height;
  height: $nav-height;
  max-height: $nav-height;
  display: block;
  transition: background-color 0.95s ease-in-out;
}
</style>
